module.exports = __webpack_public_path__ + "img/about.029c259f.jpg";